import {lazy} from 'react';

import {Route} from 'react-router-dom';

import {AdhocApptIdLoader, ApptIdLoader, ApptsLoader, EventIdLoader, EventsLoader} from 'RouteComponents';

export const MbHostLayout = lazy(() => import('../pages/mobile-client/layouts/MbHostLandingPageWrapper'));
export const Appts = lazy(ApptsLoader);
export const ApptId = lazy(ApptIdLoader);
export const AdhocApptId = lazy(AdhocApptIdLoader);
export const Events = lazy(EventsLoader);
export const EventId = lazy(EventIdLoader);
export const TestPlayground = lazy(() => import('../pages/mobile-client/TestPlayground'));

export const ClientMobileRoutes = (
  <>
    <Route element={<MbHostLayout />}>
      <Route path="appts" element={<Appts />}>
        <Route path="adhoc/:apptId" element={<AdhocApptId />} />
        <Route path=":apptId" element={<ApptId />} />
      </Route>
      <Route path="events" element={<Events />}>
        <Route path=":eventId" element={<EventId />} />
      </Route>
      {(process.env.NODE_ENV === 'development') &&
        <Route path="testplayground" element={<TestPlayground />}>
        </Route>
      }
    </Route>
  </>
);
